module.exports = "/virtual-football-league/img/amblems/left/logos/Juventus.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Juventus.png
// module id = 2100
// module chunks = 4